var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTiktok = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M24 18a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12Z",
  fill: "#000"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M24 18a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12Z",
  fill: "url(#tiktok_svg__a)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m10.394 10.351-.003-.74a5.09 5.09 0 0 0-.673-.047c-2.746-.003-4.98 2.233-4.98 4.985 0 1.687.84 3.18 2.128 4.084-.185-.674-1.27-2.078-1.27-3.388 0-2.712 2.106-4.832 4.798-4.894Z",
  fill: "#25F4EE"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.543 17.56c1.399-.088 2.26-1.005 2.291-2.232l.017-10.8c.639-.021 1.93-.003 1.916-.065a3.884 3.884 0 0 1-.062-.688h-2.706l-.004 10.858a2.277 2.277 0 0 1-2.27 2.192 2.25 2.25 0 0 1-1.058-.263c-.004.332 1.11 1.046 1.876.998ZM18.472 8.148v-.604a3.724 3.724 0 0 1-2.051-.61c.236.894 1.367 1.678 2.051 1.214Z",
  fill: "#25F4EE"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M16.421 6.933a3.744 3.744 0 0 1-.925-2.47h-.779c.187 1.032.662 2.37 1.704 2.47ZM9.721 12.269a2.278 2.278 0 0 0-2.274 2.276c0 .875.621 2.195 1.22 2.017a2.254 2.254 0 0 1-.43-1.329 2.278 2.278 0 0 1 2.274-2.276c.234 0 .46.04.673.106v-2.767a5.063 5.063 0 0 0-.673-.047c-.04 0-.077.003-.117.003l-.08 2.037c-.215-.066-.359-.02-.593-.02Z",
  fill: "#FE2C55"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "m18.472 8.148-.09 2.051c-1.405 0-2.638-.503-3.699-1.264l-.068 5.614c-.033 2.748-2.082 4.92-4.832 4.92-1.06 0-2.467-.787-2.917-.836a4.974 4.974 0 0 0 3.646 1.592 4.992 4.992 0 0 0 4.984-4.988V9.73a6.44 6.44 0 0 0 3.766 1.212V8.232c-.274 0-.537-.029-.79-.084Z",
  fill: "#FE2C55"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M14.707 14.55V9.04a6.44 6.44 0 0 0 3.766 1.212V8.148a3.764 3.764 0 0 1-2.051-1.215 3.785 3.785 0 0 1-1.653-2.47h-1.982l-.004 10.858a2.278 2.278 0 0 1-2.27 2.193c-.761 0-1.43-.377-1.847-.948a2.285 2.285 0 0 1-1.221-2.017 2.278 2.278 0 0 1 2.274-2.276c.234 0 .46.04.673.106v-2.122a4.983 4.983 0 0 0-3.525 8.376 4.962 4.962 0 0 0 2.856.904 4.995 4.995 0 0 0 4.984-4.988Z",
  fill: "#fff"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "tiktok_svg__a",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "matrix(12 0 0 12 12 12)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF004F",
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF004F",
  stopOpacity: 0.1
})))));
export default SvgTiktok;